import React from 'react';

import Table, {
    TableFooter,
    TablePagination,
    TableRow,
} from 'material-ui/Table';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';

import Grid from 'material-ui/Grid';

import {Card, CardBody, CardHeader, CardSubtitle, CardText} from 'reactstrap';

import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Typography from 'material-ui/Typography';

import Switch from 'material-ui/Switch';

import Dialog, {DialogTitle, DialogContent, DialogActions} from 'material-ui/Dialog';

import Avatar from 'material-ui/Avatar';
import {
    Close, Edit, DoneAll,
    Flight,
    Timer,
    Done, Warning, Add
} from 'material-ui-icons';

import FlightDetail from './Detail';
import FlightsFilter from './Filter';
import BookingItem from './BookingItem';
import FlightEdit from './Edit';
import FlightItem from './FlightItem';

import tsl from '../../../tsl';

import moment from 'moment-timezone';
import axios from 'axios';
import Editation from "app/used/flights/routes/Editation";

class FlightList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: 10,
            page: 1,
            total: 0,
            data: [],
            entity: {},
            displayedBookings: true,
            selected_flight: null,
            edit_flight: null,
            detail_flight: null,
            rebooking: null,
            formDisplay: false,
            statuses: [],
            filter: {
                flight_type: [],
                status: [],
                location: [],
                aircraft: [],
                date: undefined,
                orderBy: '',
                order: 'desc'   // desc / asc
            },
        };
    }

    componentDidMount() {
        // data loading will be triggered in Filter.js

        axios.get('/api/flight/statuses')
            .then((res) => {
                this.setState({
                    statuses: res.data
                })
            });
    }

    getCSVLink = () => {
        var params = this.getQueryParamsByFilter(this.state.filter);
        // forces ascending order in Flight Plan
        params['order'] = 'asc';
        params['_token'] = axios.defaults.headers.common['Authorization'].replace('Bearer ', '');
        return axios.defaults.baseURL + 'export/flights/csv?' + Object.keys(params).map(key => {
            return key + '=' + params[key];
        }).join('&');
    }

    getFlightPlanLink = () => {
        var params = this.getQueryParamsByFilter(this.state.filter);
        // forces ascending order in Flight Plan
        params['order'] = 'asc';
        params['_token'] = axios.defaults.headers.common['Authorization'].replace('Bearer ', '');
        return axios.defaults.baseURL + 'export/flights/pdf?' + Object.keys(params).map(key => {
            return key + '=' + params[key];
        }).join('&');
    }

    reloadFlightDetail = (id = null, edit = false) => {
        if (!id && this.state.detail_flight) {
            id = this.state.detail_flight.id;   // if ID not given, reload current flight detail
        }
        if (id) {
            const queryParams = {id: id};
            this.setState({detail_flight: null}); // hide detail until it's reloaded

            axios.get('/api/operator/flights', {params: queryParams})
                .then((res) => {
                    const flight = res.data.data[0];    // same structure as for list (incl. pagination)
                    let stateUpdate = {detail_flight: flight};
                    if (edit) {
                        stateUpdate.edit_flight = flight;
                    }
                    this.setState(stateUpdate);
                });
        }
    }

    getQueryParamsByFilter(filter, queryParams = {}) {

        if (filter.status.length) queryParams['status'] = filter.status.join(',');
        if (filter.location.length) queryParams['location'] = filter.location.join(',');
        if (filter.flight_type.length) queryParams['type'] = filter.flight_type.join(',');
        if (filter.aircraft.length) queryParams['aircraft'] = filter.aircraft.join(',');
        if (filter.date) queryParams['date'] = filter.date;
        if (filter.date_to) queryParams['date_to'] = filter.date_to;
        if (filter.order) queryParams['order'] = filter.order;
        if (filter.booking_id) queryParams['booking_id'] = filter.booking_id;

        return queryParams;
    }

    loadEntities(page = null, filter = null) {

        let queryParams = {
            page: page || this.state.current_page,
            perPage: this.state.rowsPerPage
        };

        queryParams = this.getQueryParamsByFilter(filter || this.state.filter);

        axios.get('/api/operator/flights', {params: queryParams})
            .then((response) => {
                //console.log(response.data);
                this.setState({
                    data: response.data.data,
                    page: response.data.current_page,
                    total: response.data.total,
                    rowsPerPage: parseInt(response.data.per_page),
                    //detail_flight: response.data.data[0]
                    //rebooking: { flight: response.data.data[0], booking: response.data.data[0].bookings[0] }
                });

                //this.reloadFlightDetail();
            });
    }

    onSave = () => {
        this.closeFlightEdit();
        this.reloadFlightDetail();
        this.loadEntities();
    }

    filterChanged = (filter) => {
        this.loadEntities(this.state.current_page, filter);
        this.setState({filter: filter});
    }

    handleChangePage(e, page) {
        this.loadEntities(page + 1);	// paginator counts pages as indexes (starting 0)
    }

    toggleCollapse = (value) => (e) => {
        this.setState({
            displayedBookings: value
        });
    }

    renderBooking = (booking, index) => {
        return (<BookingItem booking={booking}/>);
    }

    renderAdditionalFlightInfo = (flight) => {
        const flight_offer = flight.aircraft_offer.flight_offer;

        let secondaryInfo = [];
        //if (flight_offer.flight_type) secondaryInfo.push(flight_offer.flight_type.name);
        if (flight.aircraft_model) secondaryInfo.push(flight.aircraft_model.name);

        return secondaryInfo.join(' ');
    };

    cancelFlight = (e, data) => {
        (
            this.setFlightStatus(
                this.state.statuses.find(s => s.name.toUpperCase() === 'CANCELED'),
                {
                    refundType: 'PAYBACK',
                    ...(data || {})
                }
            )
        )(e);
    };

    cancelFlightWithVoucher = (e) => {
        this.cancelFlight(e, {
            refundType: 'VOUCHER'
        });
    };

    hideRefundDialog = () => {
        this.setState({
            showRefundDialog: false
        });
    };

    renderRefundDialog = () => {
        if (this.state.showRefundDialog) {
            return (
                <Dialog onClose={this.hideRefundDialog} open={true}>
                    <DialogTitle>{tsl('flights.list.dialog.refund.header')}</DialogTitle>
                    <DialogContent>
                        {tsl('flights.list.dialog.refund.text')}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideRefundDialog}>
                            {tsl('flights.list.dialog.refund.cancel')}
                        </Button>
                        <Button onClick={this.cancelFlight} color="primary" autoFocus>
                            {tsl('flights.list.dialog.refund.payback')}
                        </Button>
                        <Button onClick={this.cancelFlightWithVoucher} color="primary" autoFocus>
                            {tsl('flights.list.dialog.refund.voucher')}
                        </Button>
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    };

    renderFlightActionsDialog = () => {
        if (this.state.selected_flight != null && !this.state.showRefundDialog) {
            return (
                <Dialog onClose={this.closeFlightActions} open={true}>
                    <DialogTitle>{tsl('flights.list.dialog.actions.header')}</DialogTitle>
                    <div>
                        <List>
                            <ListItem button onClick={this.showFlightEdit(this.state.selected_flight)}>
                                <Avatar><Edit/></Avatar>
                                <ListItemText primary={tsl('flights.actions.edit_btn')}/>
                            </ListItem>
                            {this.state.statuses.map((status, index) => {
                                if (this.state.selected_flight.status.id == status.id) {
                                    return null;
                                }
                                return (
                                    <ListItem button onClick={this.setFlightStatus(status)} key={index}>
                                        {this.renderStatusIcon(status)}
                                        <ListItemText
                                            primary={tsl('flights.actions.change_status_to_1', {status: status.title})}/>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </div>
                </Dialog>
            );
        } else {
            return null;
        }
    }

    renderFlightDetailDialog = () => {
        if (this.state.detail_flight != null) {
            // open - always when generated, except when rebooking is active
            return (
                <Dialog onClose={this.closeFlightDetail} open={this.state.rebooking ? false : true}>
                    <DialogTitle>
                        {tsl('flights.detail.header')}
                    </DialogTitle>
                    <DialogContent>
                        <FlightDetail
                            flight={this.state.detail_flight}
                            onEditClick={this.showFlightEdit(this.state.detail_flight)}
                            doBookingMove={this.moveBooking}
                        />
                    </DialogContent>
                </Dialog>
            );
        } else {
            return null;
        }
    }

    showFlightDetail = (flight) => (e) => {
        this.setState({
            detail_flight: flight
        });
    }

    closeFlightDetail = (e) => {
        this.setState({
            detail_flight: null
        });
    }

    renderFlightEditDialog = () => {
        if (this.state.edit_flight != null) {
            return (
                <Dialog onClose={this.closeFlightEdit} open={true}>
                    <DialogContent>
                        <FlightEdit
                            flight={this.state.edit_flight}
                            onSave={this.onSave}
                            onClose={this.closeFlightEdit}/>
                    </DialogContent>
                </Dialog>
            );
        } else {
            return null;
        }
    }

    showFlightEdit = (flight) => () => {
        this.setState({edit_flight: flight});
    }

    closeFlightEdit = () => {
        this.setState({edit_flight: null});
    }

    setFlightStatus = (status, additionalData) => (e) => {
        if (!this.state.showRefundDialog && status.name.toUpperCase() === 'CANCELED') {
            // this flight is being cancelled
            // show refund type select dialog if there is at least 1 paid booking on this flight
            if (this.state.selected_flight.bookings && this.state.selected_flight.bookings.find(b => b.paid_at)) {

                this.setState({
                    showRefundDialog: true,
                });

                return;
            }
        } else {
            this.setState({
                showRefundDialog: false
            });
        }

        axios.post(
            '/api/operator/flights/' + this.state.selected_flight.id + '/status/' + status.id,
            additionalData || {}
        )
            .then((res) => {
                this.loadEntities();
            })
            .catch((err) => {
                console.error(err);
            });

        this.closeFlightActions();
    }

    showFlightActions = (flight) => (e) => {
        this.setState({
            selected_flight: flight
        });
    }

    closeFlightActions = (e) => {
        this.setState({
            selected_flight: null
        });
    }

    renderStatusIcon = (status) => {
        if (!status.name) {
            return null;
        }
        let bgColor = 'white',
            color = 'silver',
            icon = <Flight/>;

        switch (status.name.toUpperCase()) {
            case 'EXECUTED':
                bgColor = "white";
                color = "green";
                icon = <DoneAll/>
                break;

            case 'CONFIRMED':
                bgColor = "white";
                color = "green";
                break;

            case 'CANCELED':
                bgColor = "white";
                color = "red";
                icon = <Close/>
                break;

            case 'BOOKED':
                bgColor = "white";
                color = "silver";
                icon = <Timer/>;
        }

        return (
            <Avatar style={{color: color, backgroundColor: bgColor}}>
                {icon}
            </Avatar>
        );
    }

    moveBooking = (booking, flight) => (e) => {
        this.setState({
            rebooking: {booking: booking, flight: flight}
        });
    }

    cancelRebooking = () => {
        this.setState({
            rebooking: null
        });
    }

    rebookToNewFlight = () => {
        const {booking} = this.state.rebooking;
        axios.post('/api/operator/booking/' + booking.id + '/newFlight', {
            start_time: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
        })
            .then((res) => {
                this.cancelRebooking();
                this.reloadFlightDetail(res.data.id, true);  // set flight detail to newly created one
                this.loadEntities();
            })
    }

    rebookToFlight = (flight) => (e) => {
        const {booking} = this.state.rebooking;
        axios.post('/api/operator/booking/' + booking.id + '/moveToFlight/' + flight.id, {})
            .then((res) => {
                this.cancelRebooking();
                this.reloadFlightDetail();  // reload original flight detail
                this.loadEntities();
            })
    }

    createNew = () => {
        this.setState({
            formDisplay: true
        });
    };

    saveEntity = (model) => {
        if (model.start_time) {
            const utcTime = moment(model.start_time).utc().toISOString();
            model.start_time = utcTime;
        }

        axios.post('/api/operator/flights' + (model.flight.id ? '/' + model.flight.id : '') + '/create' + (model.aircraft.id ? '/' + model.aircraft.id : ''), model)
            .then((response) => {
                this.closeEditation();

                this.loadEntities(this.state.page);
            });
    };

    closeEditation = () => {
        this.setState({
            entity: {},
            formDisplay: false,
        });
    };

    renderRebooking = () => {
        if (this.state.rebooking) {
            const {booking, flight} = this.state.rebooking;
            return (<div>
                <Card className="shadow border-0">
                    <CardHeader className="text-white" style={{backgroundColor: 'orange'}}>
                        {tsl('flights.rebooking.select_new_flight')}
                    </CardHeader>
                    <CardBody>
                        <Grid container spacing={16}>
                            <Grid item sm={3} xs={12}>
                                <i className="zmdi zmdi-flight"/>
                                {' ' + flight.aircraft_offer.flight_offer.title}
                            </Grid>
                            <Grid item sm={2} xs={12}>
                                <i className="zmdi zmdi-accounts"/>
                                {' ' + booking.passengers.length}
                            </Grid>
                            <Grid item sm={3} xs={12}>
                                <i className="zmdi zmdi-pin"/>
                                {' ' + flight.location.name}
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <i className="zmdi zmdi-time"/>
                                {' ' + moment(flight.start_time).format('LLL')}
                            </Grid>
                        </Grid>
                        {!booking.note ? null :
                            <p><br/><i className="zmdi zmdi-quote"/> {booking.note}</p>
                        }
                        <div style={{textAlign: 'right'}}>
                            <Button className="btn btn-sm"
                                    onClick={this.cancelRebooking}
                            >
                                {tsl('flights.rebooking.cancel')}
                            </Button>
                            <Button raised className="btn btn-sm text-white" style={{backgroundColor: 'orange'}}
                                    onClick={this.rebookToNewFlight}
                            >
                                {tsl('flights.rebooking.new_flight')}
                            </Button>
                        </div>
                    </CardBody>
                </Card>
                <br/>
            </div>);
        } else {
            return null;
        }
    }

    render() {
        return (
            <div>
                <div style={this.state.formDisplay ? {} : {display: "none"}}>
                    <Editation
                        key={`${this.state.type}_${(this.state.entity && this.state.entity.id || 'new')}`}
                        ref="editationForm"
                        entityData={this.state.entity ? this.state.entity : {}}
                        saveEntity={this.saveEntity}
                        closeEditation={this.closeEditation}
                    />
                </div>
                {this.state.formDisplay ? '' :

                    <div>
                        <Button raised fab color="accent"
                                className="jr-fab-btn text-white"
                                style={{position: "fixed", bottom: 5, right: 5, zIndex: 9999}}
                                onClick={this.createNew}
                        >
                            <Add/>
                        </Button>
                        {this.renderFlightActionsDialog()}
                        {this.renderFlightDetailDialog()}
                        {this.renderFlightEditDialog()}
                        {this.renderRefundDialog()}
                        {this.renderRebooking()}
                        <FlightsFilter
                            filter={this.state.filter}
                            onChange={this.filterChanged}
                        />

                        <ListItem>
                            <Grid container spacing={16}>

                                <Grid item sm={4} xs={12}>
                                    <Button href={this.getFlightPlanLink()} target="_blank"
                                            raised color="primary" className="text-white w-100"
                                    >
                                        {tsl('flights.list.download_as_flight_plan_pdf')}
                                    </Button>
                                </Grid>

                                <Grid item sm={4} xs={12}>
                                    <Button href={this.getCSVLink()} target="_blank"
                                            raised color="primary" className="text-white w-100"
                                    >
                                        {tsl('flights.list.download_as_csv')}
                                    </Button>
                                </Grid>

                                <Grid item sm={4} xs={12}>
                                    <ListItem>
                                        <ListItemText
                                            primary={<Typography
                                                className="text-white">{tsl('flights.list.show_booking_info_switch')}</Typography>}
                                        />
                                        <ListItemSecondaryAction>
                                            <Switch
                                                onClick={this.toggleCollapse(!this.state.displayedBookings)}
                                                checked={this.state.displayedBookings}
                                            />
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                </Grid>
                            </Grid>
                        </ListItem>

                        <Paper>
                            <div className="flex-auto">
                                <div className="table-responsive-material">
                                    <List>
                                        {this.state.data.map((flight, index) => {
                                            let onMoreClick = this.showFlightActions(flight);
                                            let moreBtn = null;
                                            let moreBtnStyle = null;
                                            if (this.state.rebooking) {
                                                // not allow to merge to this flight if flight booking is exclusive
                                                if (flight.bookings[0] && flight.bookings[0].is_exclusive) {
                                                    moreBtn = null;
                                                    onMoreClick = null;
                                                } else {
                                                    // otherwise it's possible to book
                                                    moreBtnStyle = {backgroundColor: 'orange', color: 'white'};
                                                    moreBtn = <Done/>;
                                                    onMoreClick = this.rebookToFlight(flight);

                                                    // warn if available seats are less than rebooked booking number of passengers
                                                    if (flight.available_seats < this.state.rebooking.booking.passengers.length) {
                                                        moreBtn = <Warning/>
                                                    }
                                                }
                                            }

                                            return <FlightItem
                                                key={index}
                                                flight={flight}
                                                renderStatusIconFnc={this.renderStatusIcon}
                                                onListItemClick={this.showFlightDetail(flight)}
                                                onMoreClick={onMoreClick}
                                                moreBtn={moreBtn}
                                                moreBtnStyle={moreBtnStyle}
                                                showBookingInfo={this.state.displayedBookings}
                                            />
                                        }, this)}

                                    </List>

                                    <Table className="">
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    count={this.state.total}
                                                    rowsPerPage={this.state.rowsPerPage}
                                                    rowsPerPageOptions={[this.state.rowsPerPage]}
                                                    page={this.state.page - 1}
                                                    onChangePage={(e, page) => {
                                                        this.handleChangePage(e, page)
                                                    }}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </div>
                            </div>
                        </Paper>
                    </div>}
            </div>

        );
    }
}

export default FlightList;


// WEBPACK FOOTER //
// ./app/used/flights/routes/List.js